(function () {
    function fixARIAAttributes() {
      // Remove combobox role and related ARIA attributes from buttons
      document.querySelectorAll('button[role="combobox"]').forEach(el => {
        el.removeAttribute('role');
        el.removeAttribute('aria-haspopup');
        el.removeAttribute('aria-expanded');
      });
  
      // Fix Downshift input: remove role="combobox" and invalid ARIA attributes
      document.querySelectorAll('input#downshift-0-input').forEach(el => {
        // Remove role="combobox" to resolve aria-allowed-role
        el.removeAttribute('role');
        el.removeAttribute('aria-haspopup');
        el.removeAttribute('aria-autocomplete');
        el.removeAttribute('aria-controls');
        el.removeAttribute('aria-expanded');
        // Remove aria-owns if present (fixes aria-valid-attr-value)
        el.removeAttribute('aria-owns');
        // Validate aria-labelledby
        if (el.hasAttribute('aria-labelledby')) {
          const labelledbyId = el.getAttribute('aria-labelledby');
          if (!document.getElementById(labelledbyId)) {
            el.removeAttribute('aria-labelledby');
          }
        }
        // Normalize aria-invalid
        if (el.hasAttribute('aria-invalid')) {
          const invalid = el.getAttribute('aria-invalid');
          if (invalid !== 'true' && invalid !== 'false') {
            el.removeAttribute('aria-invalid');
          }
        }
      });
  
      // Fix Downshift listbox: remove invalid aria-labelledby
      document.querySelectorAll('div#downshift-0-menu[role="listbox"]').forEach(el => {
        if (el.hasAttribute('aria-labelledby')) {
          const labelledbyId = el.getAttribute('aria-labelledby');
          if (!document.getElementById(labelledbyId)) {
            el.removeAttribute('aria-labelledby');
          }
        }
      });
  
      // Fix iframe title
      document.querySelectorAll('iframe#PBarNextFrame:not([title])').forEach(iframe => {
        iframe.setAttribute('title', 'Shopify Preview Bar');
      });
    }
  
    // Run initially
    document.addEventListener('DOMContentLoaded', () => setTimeout(fixARIAAttributes, 1000));
    window.addEventListener('load', () => setTimeout(fixARIAAttributes, 2000));
  
    // Observe DOM for dynamic elements
    const observer = new MutationObserver(fixARIAAttributes);
    observer.observe(document.body, { childList: true, subtree: true });
  })();